import fetch from '@/utils/fetch'
import {shop_url} from '@/global';


const GETUSERDEAL = `${shop_url}/shop/cms/finance/trade/user` //根据条件获得用户的交易数据
const GETMERCHANT = `${shop_url}/shop/cms/finance/trade/mch`  //根据条件获得商户的交易数据
const GETCOMPANY = `${shop_url}/shop/cms/finance/trade/company`  //根据条件获得企业的交易数据
const GETCHARGE = `${shop_url}/shop/cms/finance/trade/companyRecharge` //查询充值信息
const TOTALCHARGE = `${shop_url}/shop/cms/finance/trade/recharge` //获取总充值数
const PRECHARGE = `${shop_url}/shop/cms/finance/trade/recharge/` //充值的前置接口
const GETCOMPANYINFOBYOID =`${shop_url}/shop/cms/finance/trade/show/` //根据orderID获取充值信息
const GET_COMPANYINOF_BY_PHONE = `${shop_url}/shop/cms/finance/trade/companyName/` //根据手机号获取企业信息

const TOCHARGE = `${shop_url}/shop/cms/finance/trade/confirm/` //去充值


const WAIT_PASS = `${shop_url}/shop/cms/finance/withDraw/check` //获取待审核列表
const GET_FEERATE = `${shop_url}/shop/cms/finance/withDraw/model` //获取所有提现模版
const ENSURE = `${shop_url}/shop/cms/finance/withDraw/verifySubmit` //审核确认

const WAIT_BILL= `${shop_url}/shop/cms/finance/withDraw/submit` //获取待交发票列表
const ENSURE_BILL = `${shop_url}/shop/cms/finance/withDraw/verifyBill/` //确认收到发票

const WAIT_TURN = `${shop_url}/shop/cms/finance/withDraw/trans` //
const ENSURE_TURN = `${shop_url}/shop/cms/finance/withDraw/verifyTrans/` //确认转账

const GET_COMPLETED = `${shop_url}/shop/cms/finance/withDraw/complete` //

const LOGIN_BY_PHONE=''

const EXPORT_EXCEL_USER_DEAL = `${shop_url}/shop/mp/print/user`

const GET_MERCHANTS = `${shop_url}/shop/cms/mchs` //根据关键字获取商户名
const GET_QRCODE = `${shop_url}/shop/cms/QrcodeDown` //根据关键字获取商户名
const GET_RechargeDetail =`${shop_url}/shop/cms/finance/trade/companyRecharge/info/`
const GET_COMPANYLIST =`${shop_url}/shop/cms/finance/trade/company/list`
/**
 * 获得用的教育数据，是get的方式，这个data传过来 只是为了拼到url上，商户，企业 一样
 * @param data
 * @param page
 * @param pageCount
 */
export const getUserDeal =(data,page,pageCount)=>{
  let  url = GETUSERDEAL;
  if(data){
    url = GETUSERDEAL+`?orderId=${data.orderId}&name=${data.user}&type=${data.type}&payType=${data.payType}&start=${data.start}&end=${data.end}&page=${page}&pageCount=${pageCount}&companyId=${data.companyId}`
  }
    return fetch({
      url:url,
      method:'get'
    })
}

export const  getMerchantDeal = (data,page,pageCount)=>{
  let  url = GETMERCHANT;
  if(data){
    url = GETMERCHANT+`?orderId=${data.orderId}&name=${data.name}&type=${data.type}&payType=${data.payType}&start=${data.start}&end=${data.end}&page=${page}&pageCount=${pageCount}`
  }
  return fetch({
    url:url,
    method:'get'
  })
}

export const  getCompanyDeal = (data,page,pageCount)=>{
  let  url = GETCOMPANY;
  if(data){
    url = GETCOMPANY+`?name=${data.user}&orderId=${data.orderId}&type=${data.type}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`
  }
  return fetch({
    url:url,
    method:'get'
  })
}

/**
 * 获取企业充值的记录
 * @param page
 * @param pageCount
 */
export const getChargeDeal = (data,page,pageCount)=>{
  return fetch({
    url :GETCHARGE+`?companyName=${data.companyName}&start=${data.date1}&end=${data.date2}&type=${data.type}&page=${page}&pageCount=${pageCount}`,
    method:'get'
  })
}

/**
 * 获得历史充值总计
 */
export const getTotalCharge = ()=>{
    return fetch({
      url:TOTALCHARGE,
      method:'get'
    })
}

/**
 * 充值的前置接口，当用户输入完手机号和充值金额的时候 点击下一步 调用这个接口
 * @param data
 */
export const preCharge = (data)=>{
  return fetch({
    // url:PRECHARGE+data.phone+'/'+data.money+'/'+data.accountNo,
    url:PRECHARGE,
    method:'post',
    data
  })
}



/**
 * 根据orderID获取充值信息
 * @param id
 */
export const getCompanyByOid =(id)=>{
  return fetch({
    url:GETCOMPANYINFOBYOID+id,
    method:'get'
  })
}

export const getCompanyInfoByPhone = (phone)=>{
  return fetch({
    url:GET_COMPANYINOF_BY_PHONE+phone,
    method:'get'
  })
}

/**
 * 去充值
 */
export const toCharge =(id,data)=>{
  let putData = {
    orderId:id,
    accountNo:data.accountNo,
    money:data.money
  }

  return fetch({
    url:TOCHARGE,
    method:'put',
    data:putData
  })
}

/**
 * 获取待审核列表
 * @param data
 * @param page
 * @param pageCount
 */
export const getWaitPassList =(data,page,pageCount)=>{
  return fetch({
    url:WAIT_PASS+`?name=${data.user}&feeRate=${data.feeRate}&day=${data.day}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`,
    method:'get'
  })
}

/**
 * 获得提现模版
 */
export const getFeeRate = ()=>{
  return fetch({
    url:GET_FEERATE,
    method:'get'
  })
}
/**
 * 确认审核 过或者不过
 * @param data
 */
export  const ensureOrder=(data)=>{
  return fetch({
    url:ENSURE+`?orderId=${data.orderId}&accountNo=${data.mchId}&subject=${data.subject}&money=${data.money}&status=${data.status}`,
    method:'put'
  })
}

/**
 * 获取待交发票列表
 * @param data
 * @param page
 * @param pageCount
 */
export const getWaitBillList = (data,page,pageCount)=>{
  return fetch({
    url:WAIT_BILL+`?name=${data.user}&feeRate=${data.feeRate}&day=${data.day}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`,
    method:'get'
    }
  )
}

export const ensureGetBill = (status,orderId)=>{
    return fetch({
      url:ENSURE_BILL+status+'/'+orderId,
      method:'put'
    })
}

/**
 * 获取待turn列表
 * @param data
 * @param page
 * @param pageCount
 */
export const getWaitTurnList =(data,page,pageCount)=>{
  return fetch({
    url:WAIT_TURN+`?name=${data.user}&feeRate=${data.feeRate}&day=${data.day}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`,
    method:'get'
  })
}

/**
 * 确认转账
 * @param status
 * @param orderId
 */
export  const ensureTurn =(status,orderId)=>{
  return fetch({
    url:ENSURE_TURN+status+'/'+orderId,
    method:'put'
  })
}

/**
 * 获取待完成列表
 * @param data
 * @param page
 * @param pageCount
 */
export const getCompletedList =(data,page,pageCount)=>{
  return fetch({
    url:GET_COMPLETED+`?name=${data.user}&feeRate=${data.feeRate}&day=${data.day}&start=${data.date1}&end=${data.date2}&page=${page}&pageCount=${pageCount}`,
    method:'get'
  })
}

/* 根据关键字 查询商户 */
export const getMerchantByStr = (str)=>{
  return fetch({
    url:GET_MERCHANTS+'?keywords='+str,
    method:'get'
  })
}

export const exportUserDeal =(data)=>{
  return fetch({
    url:EXPORT_EXCEL_USER_DEAL,
    method:'post',
    data:data
  })
}
// 查看已详情记录
export const refundDetail = (refundOrderId) => {
  return fetch({
    url: `${shop_url}/shop/cms/mch/order/refund/${refundOrderId}`
  })
}
// 查看充值详情记录
export const RechargeDetail = (data) => {
  return fetch({
    url: `${shop_url}/shop/cms/finance/trade/companyRecharge/info/${data.orderId}`
  })
}
// 审核充值详情
export const auditRecharge = (data) => {
  return fetch({
    url: `${shop_url}/shop/cms/finance/trade/companyRecharge/confirm`,
    method:'put',
    data
  })
}
/**
 * 获得企业列表
 */
export const getCompanyList = ()=>{
    return fetch({
      url:GET_COMPANYLIST,
      method:'get'
    })
}





// WEBPACK FOOTER //
// ./src/api/finance/index.js